import { Component, Inject } from '@angular/core';
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheet,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer } from '@angular/platform-browser';
import { ApiService } from 'src/app/services/api.service';
import { JwtService } from 'src/app/services/jwt.service';
import { MixpanelService } from 'src/app/services/mixpanel.service';
import { UploadDialog } from '../upload-dailog.component';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-games-excel',
  templateUrl: './games-excel.component.html',
  styleUrls: ['./games-excel.component.css'],
})
export class GamesExcelComponent {
  buttonClicked = false;
  success = false;
  status;

  games = {
    client: null as any,
    xl: null as any,
    zip: null as any,
  };

  constructor(
    private api: ApiService,
    private snackbar: MatSnackBar,
    private _bottomSheet: MatBottomSheet,
    private jwt: JwtService,
    private mixpanel: MixpanelService,
    private sanitizer: DomSanitizer,
    private dialog: MatDialog
  ) {}

  clients = JSON.parse(sessionStorage.getItem('clients'));
  resp = [] as any; 

  ngOnInit(): void {
    this.mixpanel.track('page_view', {
      page: 'Games Excel',
      category: 'Dashboard',
      button: '-',
    });
    this.jwt.check();
  }

  upload(status: boolean) {
    this.status = status;
    const formData = new FormData();
    formData.append('client', this.games.client);
    formData.append('excelFile', this.games.xl);
    formData.append('zipFile', this.games.zip);
    if (status) {
      const dialogRef = this.dialog.open(UploadDialog);
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.buttonClicked = true;
          this.mixpanel.track('button_click', {
            page: 'Games Excel',
            category: 'Dashboard',
            button: 'Upload',
          });
          formData.append('commit', 'yes');
          this.apiCall(formData);
        } else {
          //pass
        }
      });
    } else {
      this.buttonClicked = true;
      this.mixpanel.track('button_click', {
        page: 'Games Excel',
        category: 'Dashboard',
        button: 'Verify',
      });
      this.apiCall(formData);
    }
  }

  apiCall(formData) {
    this.api.gamesExcel(formData).subscribe(
      (data: any) => {
        this.buttonClicked = false;
        this.success = true;
        if (data.data.length > 0) {
          this.resp = this.sanitizer.bypassSecurityTrustHtml(
            data.data.join('')
          );
        } else {
          this.resp = null;
        }
        this.response(false);
        if (data.status) {
          this.snackbar.open(data.message, undefined, {
            duration: 5000,
            panelClass: 'success',
          });
        } else {
          this.snackbar.open(data.message, undefined, {
            duration: 5000,
            panelClass: 'failure',
          });
        }
      },
      (error) => {
        this.buttonClicked = false;
      }
    );
  }

  remove_xl() {
    this.games.xl = null;
  }

  onFileSelected(event: any): void {
    this.games.xl = event.target.files[0] ?? null;
    const fileReader = new FileReader();
    fileReader.onload = (e) => {
      const workbook = XLSX.read(e.target.result, { type: 'array' });
    };
    fileReader.readAsArrayBuffer(this.games.xl);
  }

  remove_img() {
    this.games.zip = null;
  }

  onFileSelected1(event: any): void {
    this.games.zip = event.target.files[0] ?? null;
  }

  response(status) {
    if (status) {
      this.mixpanel.track('button_click', {
        page: 'Games Excel',
        category: 'Dashboard',
        button: 'View Log',
      });
    }
    if (this.resp != null) {
      this._bottomSheet.open(GamesExcelResponse, { data: this.resp });
    }
  }
}

@Component({
  selector: 'games-excel-response',
  templateUrl: './games-excel-response.html',
})
export class GamesExcelResponse {
  constructor(
    private _bottomSheetRef: MatBottomSheetRef<GamesExcelComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: []
  ) {}
}
